import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import ProtectedRoute from './ProtectedRoute';

const RoleBasedRoute = ({ children, rolesAllowed }) => {
    const { currentUser, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <div>Ładowanie...</div>;
    }

    // ZMIANA: Sprawdzamy pojedynczą rolę użytkownika
    const userHasRequiredRole = currentUser && currentUser.role && rolesAllowed.includes(currentUser.role);

    if (!currentUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!userHasRequiredRole) {
        return <Navigate to="/app" state={{ message: "Nie masz uprawnień do tej strony." }} replace />;
    }

    return children;
};

const ProtectedRoleBasedRoute = ({ children, rolesAllowed }) => {
    return (
        <ProtectedRoute>
            <RoleBasedRoute rolesAllowed={rolesAllowed}>
                {children}
            </RoleBasedRoute>
        </ProtectedRoute>
    );
};

export default ProtectedRoleBasedRoute;